import { AIAgentExecutionResult, AIAgentInteractionResult } from './AIAgent'

export interface MeetingSummaryResult {
  summary?: string
  message?: string
}

export type MeetingSummaryExecutionResult = AIAgentExecutionResult<MeetingSummaryResult>
export type MeetingSummaryInteractionResult = AIAgentInteractionResult<MeetingSummaryResult>

export enum MeetingSummaryInteractionType {
  CHAT = 'chat',
  EDIT = 'edit',
  RESULT_EDIT = 'resultEdit',
}

export type EditedResult = { [key: string]: any } | { [key: string]: any }[] | null

export type EditedMeetingResult = {
  resultId: string
  resultTypeId: string
  resultTypeName: string
  result: EditedResult
}

export interface MeetingSummaryChatInteraction {
  type: MeetingSummaryInteractionType.CHAT
  query: string
}

export interface MeetingSummaryEditInteraction {
  type: MeetingSummaryInteractionType.EDIT
  newMeetingSummary: string
}

export interface MeetingSummaryResultEditInteraction {
  type: MeetingSummaryInteractionType.RESULT_EDIT
  editedResult: EditedMeetingResult
}

export type MeetingSummaryInteraction = MeetingSummaryChatInteraction | MeetingSummaryEditInteraction | MeetingSummaryResultEditInteraction
